import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import { useSelector } from "react-redux";


const DeleteOrders = ({ orderId, type, onClose, callFunc }) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const user = useSelector(state => state?.user?.user);
  const handleDeleteOrder = async () => {
    setButtonLoading(true);
    

    try {
        
      const response = await fetch(`${SummaryApi.deleteOrders.url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ orderId, orderType:type,admin:user }),
      });

      const responseData = await response.json();

      if (responseData.success) {
        toast.success(responseData.message);
       
        onClose(); // Close the modal
        callFunc(); // Refresh the list of orders
      } else {
        toast.error(responseData.message);
      }
    } catch (error) {
      toast.error("حدث خطأ أثناء محاولة حذف الطلب");
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 w-full h-full z-10 flex justify-center items-center bg-slate-200 bg-opacity-50">
      <div className="mx-auto bg-white shadow-md p-4 w-full max-w-sm text-center rounded-md">
        <button className="block ml-auto text-gray-500 hover:text-gray-800" onClick={onClose}>
          <IoMdClose size={24} />
        </button>

        <h1 className="pb-4 text-lg font-medium text-gray-800">
          هل انت متأكد أنك تريد رفض الطلب؟
        </h1>

        <div className="flex justify-around mt-4">
          <button
            className="py-2 px-6 bg-red-600 hover:bg-red-500 text-white rounded"
            onClick={handleDeleteOrder}
            disabled={buttonLoading}
          >
            {buttonLoading ? <AiOutlineLoading3Quarters className="animate-spin inline" /> : "نعم"}
          </button>
          <button
            className="py-2 px-6 bg-gray-300 hover:bg-gray-400 text-black rounded"
            onClick={onClose}
          >
            لا
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteOrders;
